import { render } from "./QGlobalPreloader.vue?vue&type=template&id=2243b5f2&scoped=true"
const script = {}

import "./QGlobalPreloader.vue?vue&type=style&index=0&id=2243b5f2&lang=scss&scoped=true"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2243b5f2"]])

export default __exports__